(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function buildSvg(el, percent) {
    const size = parseFloat(getComputedStyle(el).getPropertyValue('--cc-size')) || el.clientWidth || 96;
    const stroke = parseFloat(getComputedStyle(el).getPropertyValue('--cc-stroke')) || 8;

    const r = (size / 2) - (stroke / 2);
    const c = 2 * Math.PI * r;

    const ringColor = getComputedStyle(el).getPropertyValue('--cc-ring-color').trim() || '#c8743c';
    const trackColor = getComputedStyle(el).getPropertyValue('--cc-track-color').trim() || '#e9dfd5';

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', `0 0 ${size} ${size}`);

    const track = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    track.setAttribute('cx', size / 2);
    track.setAttribute('cy', size / 2);
    track.setAttribute('r', r);
    track.setAttribute('fill', 'none');
    track.setAttribute('stroke', trackColor);
    track.setAttribute('stroke-width', stroke);
    track.setAttribute('stroke-linecap', 'round');

    const ring = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    ring.setAttribute('cx', size / 2);
    ring.setAttribute('cy', size / 2);
    ring.setAttribute('r', r);
    ring.setAttribute('fill', 'none');
    ring.setAttribute('stroke', ringColor);
    ring.setAttribute('stroke-width', stroke);
    ring.setAttribute('stroke-linecap', 'round');
    ring.style.strokeDasharray = `${c} ${c}`;
    ring.style.strokeDashoffset = `${c}`;

    svg.appendChild(track);
    svg.appendChild(ring);

    const holder = el.querySelector('.circle-counter__svg');
    if (!holder) return;

    holder.innerHTML = '';
    holder.appendChild(svg);

    const targetOffset = c - (percent / 100) * c;

    requestAnimationFrame(() => {
      ring.style.transition = 'stroke-dashoffset 800ms ease';
      ring.style.strokeDashoffset = String(targetOffset);
    });
  }

  function init(root) {
    const nodes = (root || document).querySelectorAll('[data-circle-counter]');
    nodes.forEach((el) => {
      const raw = el.getAttribute('data-percent');
      const percent = clamp(parseFloat(raw || '0') || 0, 0, 100);
      buildSvg(el, percent);

      const onResize = () => buildSvg(el, percent);
      if (window.ResizeObserver) {
        const ro = new ResizeObserver(onResize);
        ro.observe(el);
      } else {
        window.addEventListener('resize', onResize);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();